module.exports = __webpack_public_path__ + "static/media/HU.05864261.svg";